import { useEffect, useState } from 'react';

// Tracks whether content overflows the element horizontally. Pass the element via state (not a ref object),
// so the single ResizeObserver is (re)created only when the element itself is mounted/replaced.
export const useCanScroll = (node: HTMLElement | null) => {
  const [canScroll, setCanScroll] = useState(false);

  useEffect(() => {
    if (!node) {
      setCanScroll(false);
      return;
    }

    const updateCanScroll = () => {
      setCanScroll(node.scrollWidth > node.clientWidth);
    };

    const resizeObserver = new ResizeObserver(updateCanScroll);
    resizeObserver.observe(node);
    Array.from(node.children).forEach(child => resizeObserver.observe(child));
    updateCanScroll();

    return () => resizeObserver.disconnect();
  }, [node]);

  return canScroll;
};
